import { IClientTripMonthPricesBrief } from '@bustickus/models-client';
import { ICalendarDate } from '../types';

function getWeekDayNumber(year: number, month: number, day: number) {
  const weekDayIndexSunday = new Date(year, month, day).getDay(); // 0 - Вс; 6 - Сб.
  const weekDayIndex = weekDayIndexSunday === 0 ? 6 : weekDayIndexSunday - 1; // 0 - Пн; 6 - Вс.
  return weekDayIndex;
}

function splitToWeeks(priceDates: IClientTripMonthPricesBrief): ICalendarDate[][] {
  const days = Object.keys(priceDates.prices);
  const weeks: ICalendarDate[][] = [];

  let prevDay: number | null = null;
  let week: ICalendarDate[] = [];

  for (let priceDayIndex = 0; priceDayIndex < days.length; priceDayIndex++) {
    const day = Number(days[priceDayIndex]);

    const nullCount =
      prevDay != null ? day - prevDay - 1 : getWeekDayNumber(priceDates.year, priceDates.month - 1, day);

    for (let i = 0; i < nullCount; i++) {
      week.push({
        year: priceDates.year,
        month: priceDates.month - 1,
        date: prevDay ?? 0 + i + 1,
        price: null,
        show: false,
      });

      if (week.length === 7) {
        weeks.push(week);
        week = [];
      }
    }

    const price = priceDates.prices[day];

    week.push({
      year: priceDates.year,
      month: priceDates.month - 1,
      date: day,
      price: price,
      show: true,
    });

    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }

    prevDay = day;
  }

  if (week.length > 0 && week.length < 7) {
    while (week.length < 7) {
      week.push({
        year: priceDates.year,
        month: priceDates.month - 1,
        date: (prevDay ?? 0) + week.length,
        price: null,
        show: false,
      });
    }

    weeks.push(week);
    week = [];
  }

  return weeks;
}

export default splitToWeeks;
